<template>
    <span>
        <v-layout wrap>
            <div v-show="mdAndUp" class="top-bar-bg">
                <div class="top-bar-container">
                    <div class="headline">Profile</div>
                    <v-tabs v-model="currentTab" background-color="transparent">
                        <v-tab value="profile">
                            Summary
                        </v-tab>
                        <v-tab value="edit">
                            Edit
                        </v-tab>
                        <v-tab value="password">
                            Change Password
                        </v-tab>
                        <v-tab value="notifications">
                            Settings
                        </v-tab>
                    </v-tabs>
                </div>
                <v-divider />
            </div>

            <div
                class="full-width"
                style="background-color: transparent;"
            >
                <div v-if="currentTab === 'profile'">
                    <my-profile
                        ref="myProfile"
                        :profile="profile.profile"
                        @tab-navigation="tabNavigation"
                    />
                </div>

                <div v-else-if="currentTab === 'edit'">
                    <profile-form
                        :profile="profile.profile"
                        @tab-navigation="tabNavigation"
                        @profile-updated="profileUpdated"
                    />
                </div>

                <div v-else-if="currentTab === 'password'">
                    <change-password @tab-navigation="tabNavigation" />
                </div>

                <div v-else-if="currentTab === 'notifications'">
                    <manage-notifications
                        :profile="profile.profile"
                        :user-settings="profile.userSettings"
                        :timezone-array="initialProfile.timezoneArray"
                        @tab-navigation="tabNavigation"
                    />
                </div>
            </div>
        </v-layout>
    </span>
</template>

<script>
import myProfile from 'components/Profile/ProfilePage/MyProfile/MyProfile.vue';
import changePassword from 'components/Profile/ProfilePage/PasswordChange/PasswordChange.vue';
import profileForm from 'components/Profile/ProfilePage/ProfileForm/ProfileForm.vue';
import manageNotifications from 'components/Profile/ProfilePage/ProfileSettings/ProfileSettings.vue';
import { useDisplay } from 'vuetify';

export default {
    name: 'ProfilePage',
    components: {
        profileForm,
        manageNotifications,
        myProfile,
        changePassword,
    },
    props: {
        initialProfile: {
            type: Object,
            default: null,
        },
    },
    setup() {
        const { mdAndUp } = useDisplay();
        return { mdAndUp };
    },
    data() {
        return {
            currentTab: 'profile',
            profile: {},
        };
    },
    mounted() {
        this.profile = this.initialProfile;
    },
    methods: {
        tabNavigation(value) {
            if (['profile', 'edit', 'password', 'notifications'].includes(value)) {
                this.currentTab = value;
            }
        },
        profileUpdated() {
            if (this.$refs.myProfile?.syncFromProfile) {
                this.$refs.myProfile.syncFromProfile();
            }
        },
    },
};
</script>

<style scoped />
